
<script>
kendo.pdf.defineFont({
  FontAwesome:
    "http://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.2.0/fonts/fontawesome-webfont.ttf"
});
</script>
<template>
  <div width="100%">
    <Breadcrumb :title="'FMV Statement Individual Report'"></Breadcrumb>
    <div class="form-row">
      <div class="form-group col-md-12">
        <!-- <button class="btn btn-primary" v-on:click="getPDF('.pdf-page1')" style="float:right;margin-left:10px;">Export to Pdf</button> -->
        <button class="btn btn-primary" style="float:right;" @click="gotoFMVFootnotes">
          <span class="fa fa-tag"></span>&nbsp; Tag Footnotes
        </button>
        <button class="btn btn-secondary mr-3" style="float:right;" @click="gotoFMVENTRY">
          <span class="k-icon k-i-undo"></span>&nbsp; Back to FMV Statement
        </button>
      </div>
    </div>
    <div class="input-group">
      <div class="form-group col-md-12">
        <label class="section-title">Select Report Criteria</label>
      </div>
      <br />
      <div class="input-group">
        <div class="form-group col-md-12">
          <div class="multi-field multi-field-left col-md-3">
            <label class="required-label" style="display:block">Program Type</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.ProgramType"
                :data-source="dropdownOptions.ProgramType"
                :data-text-field="'Option'"
                :option-label="'Select Program Type'"
                :data-value-field="'Option'"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="multi-field col-md-3">
            <label class="required-label" style="display:block">Partner</label>
            <div id="kendo-select">
              <kendo-autocomplete
                id="SearchFmvProgram"
                class="form-control"
                :data-source="dropdownOptions.Partner"
                :data-text-field="'Option'"
                :data-value-field="'Id'"
                :filter="'contains'"
                :placeholder="'Search for Partner'"
                @select="onPartnerChange"
              ></kendo-autocomplete>
            </div>
          </div>
          <div class="multi-field col-md-3">
            <label class="required-label" style="display:block">Tax Period</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.TaxPeriod"
                :data-source="dropdownOptions.TaxPeriod"
                :data-text-field="'Option'"
                :option-label="'Select Tax Period'"
                :data-value-field="'Option'"
                v-on:select="onTaxPeriodChange($event)"
              ></kendo-dropdownlist>
            </div>
          </div>
          <div class="multi-field multi-field-right col-md-3">
            <label class="required-label" style="display:block">Prior Tax Period</label>
            <div id="kendo-select">
              <kendo-dropdownlist
                v-model="criteriaData.PriorTaxPeriod"
                :data-source="dropdownOptions.PriorTaxPeriod"
                :data-text-field="'Option'"
                :option-label="'Select Prior Tax Period'"
                :data-value-field="'Option'"
              ></kendo-dropdownlist>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="row" style="width: 100%">
        <div class="col text-center">
          <button
            :disabled="criteriaData.ProgramType == '' || criteriaData.Partner.Id == '' || criteriaData.TaxPeriod == '' || criteriaData.PriorTaxPeriod == ''"
            class="btn btn-primary"
            style="margin:auto"
            @click="getReportData"
          >
            <span class="fa fa-list"></span>&nbsp; Run Report
          </button>
        </div>
      </div>
    </div>
    <br />
    <BaseToolBar
      v-show="displayEUM"
      :config="FMVStatementToolBarConfig"
      @buttonClicked="eumGridToolBarClick"
    ></BaseToolBar>
    <BaseGrid
      v-show="displayEUM"
      :config="EUMGridConfig"
      :data="EUMProgramTypeGridData"
      :group="gridGrouping"
      :aggregate="eumGridAggregate"
      :excelExport="excelExportFun"
    ></BaseGrid>
    <BaseToolBar
      v-show="displayEPP"
      :config="FMVStatementToolBarConfig"
      @buttonClicked="eppGridToolBarClick"
    ></BaseToolBar>
    <BaseGrid
      v-show="displayEPP"
      :config="EPPGridConfig"
      :data="EPPProgramTypeGridData"
      :group="gridGrouping"
      :aggregate="eppGridAggregate"
      :excelExport="excelExportFun"
    ></BaseGrid>
      <!--   -->
    <div v-show="isVisible" class="pdf-page1 size-a4 well" id="fmvs_memorandum">
      <div>
        <div class="row FMVbottomdoubleborder">
          <div class="col">
            <img src="@/assets/Images/Tishmanlogo.jpeg" class="FMVImgcentre" />
            <img />
          </div>
        </div>
        <div class="row FMVbottomdoubleborder">
          <div class="col">
            <p class="FMVParabold">CONFIDENTIAL MEMORANDUM</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">To:</span>
            <span class="FMVParatext">Unit Program Participants</span>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">From:</span>
            <span class="FMVParatext">Joe Doran</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">Re:</span>
            <span class="FMVParatext">Semi-Annual Unit & Direct Investment Valuations</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <br />
            <span class="FMVcolSpan FMVParatext">Date:</span>
            <span class="FMVParatext">{{ new Date()|formatDate}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <hr style="border-top:1px dotted #000;" />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" style="white-space: pre-line;">{{(MemoStartingSummary)}}</p>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" v-if="MemoProgramCurrentValueTextArray.length>0">
              Summary explanations of notable changes in
              <b>Current Values</b>
              from your {{`${criteriaData.TaxPeriod}`}} statements are as follows:
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul
              class="FMVParatext"
              v-for="(memoProgramText) in MemoProgramCurrentValueTextArray"
              :key="memoProgramText.Id"
            >
              <li>{{memoProgramText.MemoText}}</li>
            </ul>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" v-if="MemoProgramPotentialValueTextArray.length>0">
              Summary explanations of notable changes in
              <b>Potential Values</b>
              from your {{`${criteriaData.TaxPeriod}`}} statements are as follows:
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <ul
              class="FMVParatext"
              v-for="(memoProgramText) in MemoProgramPotentialValueTextArray"
              :key="memoProgramText.Id"
            >
              <li>{{memoProgramText.MemoText}}</li>
            </ul>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <p class="FMVParatext" style="white-space: pre-line;">{{MemoEndingSummary}}</p>
            <p class="page-break"></p>
          </div>
        </div>
      </div>
      <div class="new-page">
        <div v-if="EUMProgramTypeGridPdfData.length > 0 || EPPProgramTypeGridPdfData.length > 0">
          <div style="float:left">
            PARTNER:
            <span style="font-weight:bold">{{criteriaData.Partner.text.toString().toUpperCase()}}</span>
          </div>
          <div
          class="potential"
            style="float:right;margin-right:20px;margin-bottom:20px;font-weight:bold"
          >STRICTLY CONFIDENTIAL</div>
        </div>

        <div
          v-if="EUMProgramTypeGridPdfData.length > 0"
          class="potential"
          style="clear:both;font-weight:bold"
        >
          Potential and Current value statement for Employee Unit Program
          <br />
          as of {{taxDateToFilter | formatDate}} 
        </div>

        <div
          v-if="EPPProgramTypeGridPdfData.length > 0"
          class="potential"
          style="clear:both;font-weight:bold"
        >
          Potential and Current value statement for Employee Investment Program
          <br />
          as of {{taxDateToFilter | formatDate}}
        </div>
        <table class="pdf-table" id="pdf-template" v-show="EUMProgramTypeGridPdfData.length != 0">
          <thead>
            <tr>
              <td style="width:220px !important; white-space:normal !important"></td>
              <td ></td>
              <td ></td>
              <td style="width:60px !important">[A]</td>
              <td style="width:60px !important">[B]</td>
              <td style="width:60px !important">[C=A+B]</td>
              <td></td>
              <td>[D]</td>
              <td>[E=A+D]</td>
              <td></td>
              <td></td>
            </tr>
            <tr class="EUMReport">
              <th style="border:none;width:220px !importan; white-space:normal !important " attr="Investment"></th>
              <!-- <th class="th-head" attr="InvestmentID" style="border-bottom:none">Investment ID</th> -->
              <!-- border fix -->
              <th class="th-top-EPP" attr="Units" style="border-left:1px solid">Units</th>
              <th
                class="th-top-EPP"
                attr="VestedPercent"
                style="border-bottom:none;border-right:1px solid;"
              >Vesting <br>percentage<br></th>
              <th
                class="th-top-EPP"
                attr="PreviousUnitDistribution"
                style="border-bottom:none;border-right:1px solid;"
              >Previous Unit <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="ProjectedUnrealizedValue"
                style="border-bottom:none"
              >Projected <br> Unrealized Value <br>(Undiscounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValue"
                style="border-bottom:none"
              >Total <br>Potential <br>Pre-Tax <br>Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Potential <br>Pre-Tax <br>Value <br>Percentage <br>Change<br> Since <br>Prior <br>Statement<br></th>
              <th
                class="th-top-EPP"
                attr="CurrentValue"
                style="border-bottom:none"
              >Current <br>Values <br>(Discounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValue"
                style="border-bottom:none"
              >Total <br>Current <br>Pre-<br>Tax Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total Current <br>Pre-Tax Value <br>Percentage <br>Change Since <br>Prior <br>Statement<br></th>
            </tr>
          </thead>
          <tbody v-for="(item) in EUMProgramTypeGridPdfData" :key="item.Id">
            <tr v-if="item.IndexGroup == 0" class="investmentGrp-tr">
              <!-- border fix -->
              <td
                style="white-space: nowrap !important;font-weight:bold; padding-top:1.2%"
                class="text_left"
                v-html="item.InvestmentGroup.InvestmentGroup"
              ></td>
              <!-- <td colspan="9" style="border-right:1px solid"></td> -->
              <!-- border fix -->
              <td colspan="2" style="border-left:1px solid" class="border_right">&nbsp;</td>
              <td class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <!-- border fix -->
            </tr>
            <tr v-if="item.IndexGroup != 0 && item.IndexGroup != 1" class="investment-tr">
              <!-- border fix -->
              <!-- <td style="white-space: nowrap;text-transform: uppercase;" class="text_left" v-html="item.Investment"></td> -->

              <td style="white-space: normal !important;text-transform: uppercase;word-break: normal !important;
            word-wrap: break-word !important" class="text_left" v-html="item.Investment"></td>



              <!-- <td style="border-right:1px solid">{{item.InvestmentID}}</td> -->
              <!-- border fix -->
              <!-- <td class="text_center" style="border-left:1px solid">{{parseFloat(item.Units).toFixed(2)}}</td>
              hot fix -0.00 to 0.00 -->
              <td class="text_center" style="border-left:1px solid">{{parseFloat(item.Units).toFixed(2) == -0.00 ? "0.00" : parseFloat(item.Units).toFixed(2)}}</td>

              <!-- border fix -->
              <td class="text_center"
                v-show="item.VestedPercent!=null && !isNaN(item.VestedPercent)"
                style="border-right:1px solid"
              >{{(parseFloat(item.VestedPercent)*100)}}%</td>
              <td class="text_center"
                v-show="item.VestedPercent==null || isNaN(item.VestedPercent)"
                style="border-right:1px solid"
              >N/A</td>

              <td class="text_right"
                style="border-right:1px solid"
                v-show="item.PreviousUnitDistribution!=null && !isNaN(item.PreviousUnitDistribution)"
              >{{item.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0 ? "-" :item.PreviousUnitDistribution | formatDecical}}</td>

              <td class="text_right"
                style="border-right:1px solid"
                v-show="item.PreviousUnitDistribution==null || isNaN(item.PreviousUnitDistribution)"
              >{{"-"}}</td>


              <td class="text_right"
                v-show="item.ProjectedUnrealizedValue!=null && !isNaN(item.ProjectedUnrealizedValue)"
              >
              {{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" :item.ProjectedUnrealizedValue | formatDecical}}</td>

              <td class="text_right"
                v-show="item.ProjectedUnrealizedValue==null || isNaN(item.ProjectedUnrealizedValue)"
              >
              {{"-"}}</td>


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValue!=null && !isNaN(item.TotalPotentialPreTaxValue)"
              >
              {{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValue") >= 0 ? "-" :item.TotalPotentialPreTaxValue | formatDecical}}</td>


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValue==null || isNaN(item.TotalPotentialPreTaxValue)"
              >
              {{"-"}}</td>              
              <!-- 
              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" :item.TotalPotentialPreTaxValue | formatDecical}}</td> -->


              <td class="text_right"
                v-show="item.TotalPotentialPreTaxValuePercentChange!=null && !isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" :
              ((parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(2) == -0.00 ? "0.0" : (parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(1) )  +"%"   }}</td>
              
              <!-- Remove N/A and replaced with 0 -->
              <td
                v-show="item.TotalPotentialPreTaxValuePercentChange==null || isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid; padd"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" 
              : "N/A"}}</td>

              <!-- <td class="text_right">{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td> -->

              <td class="text_right"
                
                v-show="item.CurrentValue!=null && !isNaN(item.CurrentValue)"
              >{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td>

              <td class="text_right"
                v-show="item.CurrentValue==null || isNaN(item.CurrentValue)"
              >{{"-"}}</td>

              <td class="text_right"
                
                v-show="item.TotalCurrentPreTaxValue!=null && !isNaN(item.TotalCurrentPreTaxValue)"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValue") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td>

              <td class="text_right"
               
                v-show="item.TotalCurrentPreTaxValue==null || isNaN(item.TotalCurrentPreTaxValue)"
              >{{"-"}}</td>


              <!-- <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td> -->

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange!=null && !isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : 
              (parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(2) == -0.00 ? "0.0" : parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(1))+"%"}}</td>

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange==null || isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" 
              :"N/A"}}</td>
            </tr>
            <!-- border fix -->
            <!-- <br v-if="item.IndexGroup == 1" /> -->
            <tr v-if="item.IndexGroup == 1" class="total-class">
              <td style="font-weight:bold" class="text_left">TOTAL UNIT VALUE</td>
              <!-- <td style="border-right:1px solid"></td> -->
              <td style="border-left:1px solid"></td>
              <td style="border-right:1px solid"></td>
              <td class="text_right"
                style="border-right:1px solid"
              >{{item.PreviousUnitDistributionTotal | formatDecical}}</td>
              <td class="text_right">{{item.ProjectedUnrealizedValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalPotentialPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
              <td class="text_right">{{item.CurrentValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalCurrentPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
            </tr>
          </tbody>
        </table>
        <table class="pdf-table" id="pdf-template" v-show="EPPProgramTypeGridPdfData.length != 0">
          <thead>
            <tr>
              <td style="width:220px !important"></td>
              <!-- border fix -->
              <!--  <td></td> -->
              <td colspan="3" class="fullborder">Commitments</td>
              <!-- <td></td> -->
              <td>[A]</td>
              <td>[B]</td>
              <td>[C=A+B]</td>
              <td></td>
              <td>[D]</td>
              <td>[E=A+D]</td>
              <td></td>
            </tr>
            <tr class="EPPReport">
              <th style="border:none" attr="Investment"></th>
              <th class="th-top-EPP" attr="CommitmentFunded" style="border-left:1px solid">Funded<br></th>
              <th class="th-top-EPP" attr="CommitmentRemaining" style="border-bottom:none">Remaining<br></th>
              <th
                class="th-top-EPP"
                attr="CommitmentTotal"
                style="border-bottom:none;border-right:1px solid"
              >Total<br></th>
              <th
                class="th-top-EPP"
                attr="PreviousUnitDistribution"
                style="border-bottom:none;border-right:1px solid;font-size: 6px"
              >Previous<br>Cash <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="ProjectedUnrealizedValue"
                style="border-bottom:none"
              >Projected <br>Remaining <br>Distributions<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValue"
                style="border-bottom:none"
              >Total <br>Projected <br>Pre-Tax Value <br>(Undiscounted)<br></th>
              <th
                class="th-top-EPP"
                attr="TotalPotentialPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Potential <br>Pre-Tax <br>Value <br>Percentage <br>Change <br>Since <br>Prior <br>Statement<br></th>
              <th
                class="th-top-EPP"
                attr="CurrentValue"
                style="border-bottom:none"
              >Current <br>Values <br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValue"
                style="border-bottom:none"
              >Total <br>Current <br>Pre-Tax <br>Value<br></th>
              <th
                class="th-top-EPP"
                attr="TotalCurrentPreTaxValuePercentChange"
                style="border-right:1px solid"
              >Total <br>Current <br>Pre-Tax <br>Value <br>Percentage <br>Change <br>Since <br>Prior <br>Statement<br></th>
            </tr>
          </thead>
          <tbody v-for="(item) in EPPProgramTypeGridPdfData" :key="item.Id">
            <tr v-if="item.IndexGroup == 0" class="investmentGrp-tr">
              <!-- border fix -->
              <td
                class="text_left"
                style="white-space: nowrap;font-weight:bold;padding-top:1.2%; text-decoration: underline;"
                v-html="item.InvestmentGroup.InvestmentGroup"
              ></td>
              <!-- <td colspan="10" style="border-right:1px solid"></td> -->
              <!-- border fix -->
              <td colspan="3" style="border-left:1px solid" class="border_right">&nbsp;</td>
              <td class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <td colspan="3" class="border_right">&nbsp;</td>
              <!-- border fix -->
            </tr>
            <tr v-if="item.IndexGroup != 0 && item.IndexGroup != 1" class="investment-tr">
              <!-- border fix -->
              <td class="text_left" style="white-space: normal !important;text-transform: uppercase;word-break: normal !important;
            word-wrap: break-word !important" v-html="item.Investment"></td>
            <td class="text_right" style="border-left:1px solid">{{item.CommitmentFunded | formatDecical}}</td>
              <td>{{item.CommitmentRemaining | formatDecical}}</td>

              <td class="text_right" style="border-right:1px solid">{{item.CommitmentTotal | formatDecical}}</td>

              <td class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0 ? "-" : item.PreviousUnitDistribution | formatDecical}}</td>
              <td v-show="item.ProjectedUnrealizedValue!=null && !isNaN(item.ProjectedUnrealizedValue)" class="text_right">{{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" : item.ProjectedUnrealizedValue | formatDecical}}</td>
              <td  v-show="item.ProjectedUnrealizedValue==null || isNaN(item.ProjectedUnrealizedValue)"  class="text_right">
                {{item.HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0 ? "-" : "N/A"}}</td>
              <td v-show="item.TotalPotentialPreTaxValue!=null && !isNaN(item.TotalPotentialPreTaxValue)" class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" : item.TotalPotentialPreTaxValue | formatDecical}}</td>
              <td  v-show="item.TotalPotentialPreTaxValue==null || isNaN(item.TotalPotentialPreTaxValue)"  class="text_right">
                {{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValues") >= 0 ? "-" : "N/A"}}</td>

              <td 
                v-show="item.TotalPotentialPreTaxValuePercentChange!=null && !isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" :
              ((parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(2) == -0.00 ? "0.0" : (parseFloat(item.TotalPotentialPreTaxValuePercentChange)*100).toFixed(1) )  +"%"   }}</td>
              <td
                v-show="item.TotalPotentialPreTaxValuePercentChange==null || isNaN(item.TotalPotentialPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0 ? "-" : "N/A"}}</td>

              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("CurrentValue") >= 0 ? "-" :item.CurrentValue | formatDecical}}</td>
              <td class="text_right">{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValues") >= 0 ? "-" :item.TotalCurrentPreTaxValue | formatDecical}}</td>

              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange!=null && !isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : 
              (parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(2) == -0.00 ? "0.0" : parseFloat(item.TotalCurrentPreTaxValuePercentChange*100).toFixed(1))+"%"}}</td>
              <td
                v-show="item.TotalCurrentPreTaxValuePercentChange==null || isNaN(item.TotalCurrentPreTaxValuePercentChange)"
                class="text_right"
                style="border-right:1px solid"
              >{{item.HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0 ? "-" : "N/A"}}</td>
            </tr>
            <!-- border fix -->
            <!-- <br v-if="item.IndexGroup == 1" /> -->
            <tr v-if="item.IndexGroup == 1" class="total-class">
              <td class="text_left" style="font-weight:bold">TOTAL DIRECT INVESTMENT VALUE</td>
              <td class="text_right" style="border-left:1px solid">{{item.CommitmentFundedTotal | formatDecical}}</td>
              <td class="text_right">{{item.CommitmentRemainingTotal | formatDecical}}</td>
              <td style="border-right:1px solid">{{item.CommitmentValueTotal | formatDecical}}</td>
              <td class="text_right"
                style="border-right:1px solid"
              >{{item.PreviousUnitDistributionTotal | formatDecical}}</td>
              <td class="text_right">{{item.ProjectedUnrealizedValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalPotentialPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
              <td class="text_right">{{item.CurrentValueTotal | formatDecical}}</td>
              <td class="text_right">{{item.TotalCurrentPreTaxValueTotal | formatDecical}}</td>
              <td style="border-right:1px solid"></td>
            </tr>
          </tbody>
        </table>
        <br />
        <div class="row">
          <div
            v-if="EUMProgramTypeGridPdfData.length > 0 || EPPProgramTypeGridPdfData.length > 0"
            class="col"
            >
            <!-- <ul id="v-for-object" class="demo">
              <li
                v-for="note in footnotes"
                :key="note.InvestmentID"
              >{{ note.TagNumber }} {{"-"}} {{note.Footnote}}</li>
            </ul>-->
            <!-- // for pdf -->
            <table class="pdf-footnote2">
              <thead>
                <tbody v-for="note in footnotes" :key="note.InvestmentID">
                <tr >
                  <td  style="text-align:left;vertical-align:top;padding:1;">{{"["+ note.TagNumber +"]" }}</td>
                 <!-- <tr class="blank_row">
                    <td colspan="2"></td>
                  </tr> -->
                  <td style="text-align:left;vertical-align:top;padding:1;">{{note.Footnote}} <br /></td>
                  <td styple="padding:1;"></td>
                </tr>
                <tr> </tr>

                </tbody>

              </thead>
            </table> 
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div
        v-if="EUMProgramTypeGridPdfData.length > 0 || EPPProgramTypeGridPdfData.length > 0"
        class="col"
      >
        <!-- <ul id="v-for-object" class="demo">
          <li
            v-for="note in footnotes"
            :key="note.InvestmentID"
          >{{ note.TagNumber }} {{"-"}} {{note.Footnote}}</li>
        </ul>-->
        <table style="font-size:10px">
          <thead>
            <tbody v-for="note in footnotes" :key="note.InvestmentID">
            <tr >
              <td  style="text-align:left;vertical-align:top;padding:1;">{{"["+ note.TagNumber +"]" }}</td>
             <!-- <tr class="blank_row">
                <td colspan="2"></td>
              </tr> -->
              <td style="text-align:left;vertical-align:top;padding:1;">{{note.Footnote}} <br /></td>
              <td styple="padding:1;"></td>
            </tr>
            <tr> </tr>

            </tbody>

          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import linq from "linq";

import BaseGrid from "@/components/base/BaseGrid.vue";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import funcUtil from "@/services/funcUtil.js";
import apiUtil from "@/services/apiUtil.js";
import deepGroupBy from "@/services/groupByUtil.js";

import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelInvestment from "@/models/BaseModelInvestment.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import BaseModelDistribution from "@/models/BaseModelDistribution.js";
import BaseModelAllocation from "@/models/BaseModelAllocation.js";
import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";
import BaseModelFMVStatementFootnote from "@/models/BaseModelFMVStatementFootnote.js";
import BaseModelFootnote from "@/models/BaseModelFootnote.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseModelMemo from "@/models/BaseModelMemo.js";
import BaseModelUnitRunningTotal from "@/models/BaseModelUnitRunningTotal.js";
import BaseInvestmentValuation from "@/models/BaseModelInvestmentValuation.js"
import { saveExcel } from "@progress/kendo-vue-excel-export";
import moment from "moment";
import {
  EUMGridConfig,
  EPPGridConfig,
  FMVStatementToolBarConfig
} from "./FMVSReportConfig.js";

import { mapGetters } from "vuex";
import FMVMixin from "@/mixins/FMVMixin.js";

export default {
  name: "FmvStatement",
  mixins: [toolbarUtility, apiUtil, funcUtil, FMVMixin],

  components: {
    Breadcrumb,
    BaseGrid,
    BaseToolBar
  },

  computed: {
    ...mapGetters("getModule", [
      "withFilter",
      "getAllItemFilter",
      "getLocalInputControls",
      "getJoinedItemsFilter"
    ])
  },

  data: function() {
    return {
      BaseModelPartner: BaseModelPartner,
      BaseModelProgram: BaseModelProgram,
      BaseModelInvestment: BaseModelInvestment,
      BaseModelInputControl: BaseModelInputControl,
      BaseModelTransactionLog: BaseModelTransactionLog,
      BaseModelDistribution: BaseModelDistribution,
      BaseModelAllocation: BaseModelAllocation,
      BaseModelDirectInvestmentValuation: BaseModelDirectInvestmentValuation,
      BaseModelFMVStatementFootnote: BaseModelFMVStatementFootnote,
      BaseModelFootnote: BaseModelFootnote,
      BaseModelVesting: BaseModelVesting,
      BaseModelMemo: BaseModelMemo,
      BaseModelUnitRunningTotal: BaseModelUnitRunningTotal,
      BaseInvestmentValuation : BaseInvestmentValuation,

      FMVStatementToolBarConfig: FMVStatementToolBarConfig,

      EUMGridConfig: EUMGridConfig,
      EPPGridConfig: EPPGridConfig,

      gridGrouping: {
        field: "InvestmentGroup",
        dir: "desc"
      },

      eumGridAggregate: [
        {
          field: "PreviousUnitDistribution",
          aggregate: "sum"
        },
        {
          field: "ProjectedUnrealizedValue",
          aggregate: "sum"
        },
        {
          field: "TotalPotentialPreTaxValue",
          aggregate: "sum"
        },
        {
          field: "CurrentValue",
          aggregate: "sum"
        },
        {
          field: "TotalCurrentPreTaxValue",
          aggregate: "sum"
        }
      ],

      eppGridAggregate: [
        {
          field: "CommitmentFunded",
          aggregate: "sum"
        },
        {
          field: "CommitmentRemaining",
          aggregate: "sum"
        },
        {
          field: "CommitmentTotal",
          aggregate: "sum"
        },
        {
          field: "PreviousUnitDistribution",
          aggregate: "sum"
        },
        {
          field: "ProjectedUnrealizedValue",
          aggregate: "sum"
        },
        {
          field: "TotalPotentialPreTaxValue",
          aggregate: "sum"
        },
        {
          field: "CurrentValue",
          aggregate: "sum"
        },
        {
          field: "TotalCurrentPreTaxValue",
          aggregate: "sum"
        }
      ],

      dropdownOptions: {
        ProgramType: {
          model: "",
          dataSource: []
        },
        Partner: {
          model: "",
          dataSource: []
        },
        TaxPeriod: {
          model: "",
          dataSource: []
        },
        PriorTaxPeriod: {
          model: "",
          dataSource: []
        }
      },

      criteriaData: {
        ProgramType: "", //EUM  -- EPP
        Partner: {
          Id: "",
          text: ""
        }, // {Id: "7", text: "Partner 97"} -- {Id: "20", text: "Partner 34"}
        TaxPeriod: "", //2018 Q4
        PriorTaxPeriod: "" //2018 Q2
      },
      priorTaxPeriod: "",
      taxDateToFilter: "",
      priorTaxDateToFilter: "",

      ProgramandUnit: [],
      Distribution: [],
      PriorDistribution: [],
      Investment: [],
      Vesting: [],
      Valuation: [],
      PriorValuation: [],

      ContributionDistributionValuation: [],
      PriorContributionDistributionValuation: [],
      EPPInvestment: [],

      displayEUM: false,
      EUMProgramTypeGridData: [],
      displayEPP: false,
      EPPProgramTypeGridData: [],
      strFootnotes: "",
      EUMProgramTypeGridPdfData: [],
      EPPProgramTypeGridPdfData: [],
      ExcelEUMGridConfig : [],
      ExcelEPPGridConfig : [],

      footnotes: [],
      investmentSuperScript: [],
      investmentGroupSuperScript: [],
      MemoStartingSummary: "",
      MemoEndingSummary: "",
      MemoProgramTextArray: [],
      MemoProgramCurrentValueTextArray: [],
      MemoProgramPotentialValueTextArray: [],
      isVisible: false
    };
  },

  mounted() {
    const self = this;

    self.getInputControls();
    self._loadGridSettings(self.EUMGridConfig.grid.gridId);
    self._loadGridSettings(self.EPPGridConfig.grid.gridId);

    //Bind databound event to grid
    var eumGrid = $("#" + self.EUMGridConfig.grid.gridId).data("kendoGrid");
    eumGrid.bind("dataBound", self.getSuperScript);

    var eppGrid = $("#" + self.EPPGridConfig.grid.gridId).data("kendoGrid");
    eppGrid.bind("dataBound", self.getSuperScript);
    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchFmvProgram");
  },

  methods: {
    excelExportFun: function (e) {
      //debugger;
      e.workbook.fileName =
        kendo.toString(new Date(), "dd/MM/yyyy HH:mm") + " Grid.xlsx";
    },
    onPartnerChange: function(e) {
      const self = this;
      self.criteriaData.Partner.Id = e.dataItem.Id;
      self.criteriaData.Partner.text = e.dataItem.Option;
    },

    gotoFMVFootnotes: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.$router.push("/valuation/fmvs/footnote");
    },

    gotoFMVENTRY: function(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      this.$router.push("/valuation/fmvs");
    },

    // getPDF(selector, output) {
    //   //$(selector).css("display", "block");
    //   const self = this;
    //   self.isVisible = true;
    //   kendo.drawing
    //     .drawDOM($(selector), {
    //       forcePageBreak: ".new-page",
    //       paperSize: "A4",
    //       landscape: false,
    //       scale: 0.7
    //     })
    //     .then(function(group) {
    //       kendo.drawing.pdf.saveAs(group, "EUMPartner.pdf");
    //     })
    //     .done(res => {
    //       self.isVisible = false;
    //     });
    //   //$(selector).css("display", "none");
    // },
    getExcel() {
      const self = this;
      ////debugger;
      var selectedItem = [];
      grid.select().each(function () {
        //push the dataItem into the array
        selectedItem.push(grid.dataItem(this));
      });

      //return if no selected item

      if (selectedItem.length < 1) {
        //alert("Please Select Rows for Exporting")
        this._AlertPopup("Please Select Rows for Exporting", "info");

        return;
      }
      saveExcel({
        data: self.EUMProgramTypeGridData,
        fileName: self.getExportedFileName("Excel"),
        columns: [
          { field: "Investment" },
          { field: "VestedPercent", title: "Vesting Percentage" },
        ],
      });
    },
    getExportedFileName(reportType) {
      const self = this;
      let filterPartner = {
        filter:
          "ReceiveFMV eq 'Yes' and Id eq '" +
          self.criteriaData.Partner.Id +
          "'",
      };
      let resPartner = self.withFilter(
        self.BaseModelPartner.list,
        filterPartner
      );
      var TSDocSplitLength = resPartner[0].TSDocId.toString().split("-").length;
      var ssn = resPartner[0].TSDocId.toString().split("-")[
        TSDocSplitLength - 1
      ];
      var extension =
        reportType == "Excel" ? "xlsx" : reportType == "Pdf" ? "pdf" : "xlsx";
      var downloadedFileName =
        ssn +
        "_" +
        self.criteriaData.Partner.text +
        "_" +
        self.criteriaData.TaxPeriod +
        "_FMV Report." +
        extension;
      return downloadedFileName;
    },

    getPDF(selector, output) {
      //$(selector).css("display", "block");
      const self = this;
      let filterPartner = {
        filter: "ReceiveFMV eq 'Yes' and Id eq '"+self.criteriaData.Partner.Id+"'"
      };
      let resPartner = self.withFilter(
        self.BaseModelPartner.list,
        filterPartner
      );
      var TSDocSplitLength=resPartner[0].TSDocId.toString().split('-').length;
      var ssn=resPartner[0].TSDocId.toString().split('-')[TSDocSplitLength-1]
      var downloadedFileName=ssn+"_"+self.criteriaData.Partner.text+"_"+self.criteriaData.TaxPeriod+"_FMV Report.pdf"
      self.isVisible = true;
      self.$nextTick(function() {
        self.headerSuperscript();
      kendo.drawing
        .drawDOM($(selector), {
          forcePageBreak: ".page-break",
          multiPage: true,
          allPages: true,
          paperSize: "A4",
          landscape: false,
          repeatHeaders:true,
          scale: 0.7
        })
        .then(function(group) {
          kendo.drawing.pdf.saveAs(group, self.getExportedFileName("Pdf"));
        })
        .done(res => {
          self.isVisible = false;
        });
      })

      //$(selector).css("display", "none");
    },
    
    headerSuperscript() {
      let self = this;

      let EUMresponse = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        {
          filter:
            "TaxPeriod eq '" +
            self.criteriaData.TaxPeriod +
            "' and Page eq 'EUM'"
        }
      );

      if (EUMresponse.length) {



        EUMresponse = EUMresponse.sort((a,b) => {
          return a.TagNumber > b.TagNumber ? 1 : -1
        })



        for (var i = 0; i < EUMresponse.length; i++) {
          if (EUMresponse[i].Column != "" && EUMresponse[i].Column != null) {
            if (EUMresponse[i].Column.length) {
              var eumColumnArray = [];
              if (EUMresponse[i].Column.indexOf(",") < 0) {
                eumColumnArray[0] = EUMresponse[i].Column;
              } else {
                eumColumnArray = EUMresponse[i].Column.split(",");
              }

              eumColumnArray.forEach(element => {
                $("table.pdf-table thead tr.EUMReport th").each(function() {
                  if ($(this).attr("attr") == element) {
                    let chkTitleSuperScript = $(this)[0].innerHTML.indexOf(
                      "<sup>[" + EUMresponse[i].TagNumber + "]</sup>"
                    );
                    if (chkTitleSuperScript < 0) {
                      // $(this).html(
                      //   $(this).text() +
                      //     "<sup>[" +
                      //     EUMresponse[i].TagNumber +
                      //     "]</sup>"
                      // );

                      $(this)[0].innerHTML =
                        $(this)[0].innerHTML +
                        "<sup>[" +
                        EUMresponse[i].TagNumber +
                        "]</sup>";
                    }
                  }
                });
              });
            }
          }
        }
      }

      let EPPresponse = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        {
          filter:
            "TaxPeriod eq '" +
            self.criteriaData.TaxPeriod +
            "' and Page eq 'EPP'"
        }
      );

      if (EPPresponse.length) {
        for (var i = 0; i < EPPresponse.length; i++) {
          if (EPPresponse[i].Column != "" && EPPresponse[i].Column != null) {
            if (EPPresponse[i].Column.length) {
              var eppColumnArray = [];
              if (EPPresponse[i].Column.indexOf(",") < 0) {
                eppColumnArray[0] = EPPresponse[i].Column;
              } else {
                eppColumnArray = EPPresponse[i].Column.split(",");
              }

              eppColumnArray.forEach(element => {
                $("table.pdf-table thead tr.EPPReport th").each(function() {
                  if ($(this).attr("attr") == element) {
                    let chkTitleSuperScript = $(this)[0].innerHTML.indexOf(
                      "<sup>[" + EPPresponse[i].TagNumber + "]</sup>"
                    );
                    if (chkTitleSuperScript < 0) {
                      // $(this).html(
                      //   $(this).text() +
                      //     "<sup>[" +
                      //     EUMresponse[i].TagNumber +
                      //     "]</sup>"
                      // );

                      $(this)[0].innerHTML =
                        $(this)[0].innerHTML +
                        "<sup>[" +
                        EPPresponse[i].TagNumber +
                        "]</sup>";
                    }
                  }
                  
                });
              });
            }
          }
        }
      }
    },



    eumGridToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id == "btnRefresh") {
        self.refreshGrid();
      } else if (e.id == "btnExportPdf") {
        if (self.EUMProgramTypeGridData.length > 0) self.getPDF(".pdf-page1");
      }else if (e.id == "btnExportExcel") {
        ////debugger;
        if (self.EUMProgramTypeGridData.length > 0) self.getExcel();
      }
            let PartnerFilter = {
        filter: "Id eq '" + self.criteriaData.Partner.Id + "'",
      };
      let Partner = self.withFilter(
        self.BaseModelPartner.list,
        PartnerFilter
      )[0];
      console.log("Excel Export",Partner);
      var HireDate=Partner.HireDate!=null?Partner.HireDate:"";
      var headerList = [
        { id: "Partner Name", value: self.criteriaData.Partner.text },
        { id: "Type of Program", value: self.criteriaData.ProgramType },
        { id: "Hire Date", value: moment(HireDate).format("MM/DD/YYYY") },
        { id: "Tax Period", value: self.criteriaData.TaxPeriod },
        { id: "Prior Tax Period", value: self.criteriaData.PriorTaxPeriod },
        {
          id: "Report Generated On",
          value: kendo.toString(new Date(), "MM/dd/yyyy"),
        },
      ];
      var arguementList = {
        ...arguments,
        fileName: self.getExportedFileName("Excel"),
          //"FMV Report_" + kendo.toString(new Date(), "MM-dd-yyyy") + ".xlsx",
        headers: headerList,
      };
      self._baseToolBarEvents(self.ExcelEUMGridConfig.grid.gridId, arguementList);
    },

    eppGridToolBarClick(e) {
      const self = this;
      e.preventDefault();
      if (e.id == "btnRefresh") {
        self.refreshGrid();
      } else if (e.id == "btnExportPdf") {
        if (self.EPPProgramTypeGridData.length > 0) self.getPDF(".pdf-page1");
      } else if (e.id == "btnExportExcel") {
        ////debugger;
        if (self.EPPProgramTypeGridData.length > 0) self.getExcel();
      }      
      let PartnerFilter = {
        filter: "Id eq '" + self.criteriaData.Partner.Id + "'",
      };
      let Partner = self.withFilter(
        self.BaseModelPartner.list,
        PartnerFilter
      )[0];
      //console.log(""Partner);
      var HireDate=Partner.HireDate!=null?Partner.HireDate:"";
      var headerList = [
        { id: "Partner Name", value: self.criteriaData.Partner.text },
        { id: "Type of Program", value: self.criteriaData.ProgramType },
        { id: "Hire Date", value: moment(HireDate).format("MM/DD/YYYY") },
        { id: "Tax Period", value: self.criteriaData.TaxPeriod },
        { id: "Prior Tax Period", value: self.criteriaData.PriorTaxPeriod },
        {
          id: "Report Generated On",
          value: kendo.toString(new Date(), "MM/dd/yyyy"),
        },
      ];
      var arguementList = {
        ...arguments,
        fileName: self.getExportedFileName("Excel"),
          //"FMV Report_" + kendo.toString(new Date(), "MM-dd-yyyy") + ".xlsx",
        headers: headerList,
      };
      self._baseToolBarEvents(self.ExcelEPPGridConfig.grid.gridId, arguementList);
    },

    refreshGrid: function() {
      this.getReportData();
    },

    getInputControls: function() {
      const self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );

      self.dropdownOptions["ProgramType"] = response["FMVPage"];

      self.dropdownOptions["TaxPeriod"] = response["TaxPeriod"].sort((a, b) =>
        a.Option < b.Option ? -1 : 1
      );

      let filterPartner = {
        filter: "ReceiveFMV eq 'Yes'"
      };

      let resPartner = self.withFilter(
        self.BaseModelPartner.list,
        filterPartner
      );

      var partnerData = [];
      if (resPartner.length) {
        resPartner.forEach(item => {
          let obj = {};
          obj.Id = item.Id;
          obj.Option = item.FullName;
          partnerData.push(obj);
        });
      }

      self.dropdownOptions["Partner"] = partnerData.sort((a, b) =>
        a.Option < b.Option ? -1 : 1
      );
    },

    onTaxPeriodChange: function(e) {
      const self = this;
      let priorTaxPeriod = self.dropdownOptions["TaxPeriod"];

      let i = priorTaxPeriod.findIndex(item => {
        return item["Option"] === e.dataItem.Option;
      });

      let filteredPriorTaxPeriod = priorTaxPeriod.slice(0, i);
      self.dropdownOptions["PriorTaxPeriod"] = filteredPriorTaxPeriod.sort(
        (a, b) => {
          a.Option < b.Option ? -1 : 1;
        }
      );
    },

    getTaxandPriorTaxPeriod: function(taxYear, taxQuarter) {
      if (taxQuarter == "Q1") {
        return taxYear + "/3/31";
      } else if (taxQuarter == "Q2") {
        return taxYear + "/6/30";
      } else if (taxQuarter == "Q3") {
        return taxYear + "/9/30";
      } else {
        return taxYear + "/12/31";
      }
    },

    getReportData: function(e) {
      e.preventDefault();
      const self = this;
      self.ProgramandUnit = [];
      self.Distribution = [];
      self.PriorDistribution = [];
      self.Investment = [];
      self.Vesting = [];
      self.Valuation = [];
      self.PriorValuation = [];

      self.ContributionDistributionValuation = [];
      self.PriorContributionDistributionValuation = [];
      self.EPPInvestment = [];

      self.displayEUM = false;
      self.EUMProgramTypeGridData = [];
      self.displayEPP = false;
      self.EPPProgramTypeGridData = [];
      self.EUMProgramTypeGridPdfData = [];
      self.EPPProgramTypeGridPdfData = [];

      //Empty Memo Data
      (self.MemoStartingSummary = ""),
        (self.MemoEndingSummary = ""),
        (self.MemoProgramTextArray = []),
        (self.MemoProgramCurrentValueTextArray = []),
        (self.MemoProgramPotentialValueTextArray = []);
      // Find the PriorTaxPeriod, TaxDate and PriorTaxDate to filter the data.
      if (self.criteriaData.TaxPeriod.length) {
        //Get Dynamic Memo Text
        let memoFilter = {
          filter: "TaxPeriod eq '" + self.criteriaData.TaxPeriod + "'"
        };
        let MemoDataByTaxPeriod = this.withFilter(
          BaseModelMemo.list,
          memoFilter
        );
        if (MemoDataByTaxPeriod && self.criteriaData.Partner.Id > 0) {
          let startSummary = _.filter(MemoDataByTaxPeriod, function(item) {
            return item.MemoType == "Starting Summary";
          });
          self.MemoStartingSummary =
            startSummary && startSummary[0] ? startSummary[0].MemoText : "";

          let endSummary = _.filter(MemoDataByTaxPeriod, function(item) {
            return item.MemoType == "Ending Summary";
          });

          self.MemoEndingSummary =
            endSummary && endSummary[0] ? endSummary[0].MemoText : "";

          //Program Text for the Partner with the Associated Program.
          let AssociatedPrograms = self.getAssociatedPrograms(
            self.criteriaData.Partner.Id
          );
          let AsscoiatedInvestment = self.getAssociatedInvestment(
            AssociatedPrograms
          );

          self.MemoProgramTextArray = self.getProgramInvestmentText(
            MemoDataByTaxPeriod,
            AssociatedPrograms,
            AsscoiatedInvestment
          );
          self.MemoProgramCurrentValueTextArray = self.MemoProgramTextArray.filter(
            x => x.Location != "Potential Value"
          );
          self.MemoProgramPotentialValueTextArray = self.MemoProgramTextArray.filter(
            x => x.Location == "Potential Value"
          );
        }

        let selectedTaxPeriod = _.split(
          self.criteriaData.TaxPeriod.toString(),
          " "
        );

        let selectedPriorTaxPeriod = _.split(
          self.criteriaData.PriorTaxPeriod.toString(),
          " "
        );

        // pervious year of taxperiod  and  qauter of priortaxperiod
        self.taxDateToFilter = self.getTaxandPriorTaxPeriod(
          selectedTaxPeriod[0],
          selectedTaxPeriod[1]
        );

        self.priorTaxPeriod = self.criteriaData.PriorTaxPeriod;

        self.priorTaxDateToFilter = self.getTaxandPriorTaxPeriod(
          selectedPriorTaxPeriod[0],
          selectedPriorTaxPeriod[1]
        );
      }
      console.log(self.criteriaData, "FilterData");
      console.log(self.taxDateToFilter, "taxdate");
      console.log(self.priorTaxPeriod, "Prior Tax Period");
      console.log(self.priorTaxDateToFilter, "Prior Tax date");

      let loader = this.$loading.show();
      var delayInMilliseconds = 1000; //1 second

      setTimeout(function() {
        /* Selected Program Type is EUM */
        if (self.criteriaData.ProgramType == "EUM") {
          self.displayEUM = true;
          self.displayEPP = false;
          self.formEUMGridData();
          self.getFootNotes("EUM");
        } else if (self.criteriaData.ProgramType == "EPP") {
          self.displayEUM = false;
          self.displayEPP = true;
          self.formEPPGridData();
          self.getFootNotes("EPP");
        }
        loader.hide();
      }, delayInMilliseconds);
    },

    getFootNotes(EumOREpp) {
      const self = this;
      self.footnotes = [];

      let footnoteQuery = {
        filter:
          "TaxPeriod eq '" +
          self.criteriaData.TaxPeriod +
          "' and Page eq '" +
          self.criteriaData.ProgramType +
          "'"
      };

      let response = self.withFilter(
        self.BaseModelFMVStatementFootnote.list,
        footnoteQuery
      );

      var gridConfigForColumnTitle;
      var gridDataForInvestmentAndGroup;
      if (EumOREpp == "EUM") {
        self.ExcelEUMGridConfig = self.EUMGridConfig;
        gridConfigForColumnTitle = self.EUMGridConfig;
        gridDataForInvestmentAndGroup = self.EUMProgramTypeGridData;
        self.investmentSuperScript = [];
        self.investmentGroupSuperScript = [];
      } else if (EumOREpp == "EPP") {
        self.ExcelEPPGridConfig = self.EPPGridConfig;
        gridConfigForColumnTitle = self.EPPGridConfig;
        gridDataForInvestmentAndGroup = self.EPPProgramTypeGridData;
        self.investmentSuperScript = [];
        self.investmentGroupSuperScript = [];
      }

      if (response.length) {


        // Sort by number and alphabets
        const compare = (a,b) => {

          // check for numberhood
          const numA = !isNaN(a.TagNumber);
          const numB = !isNaN(b.TagNumber);
          if(numA && numB){
          	return Number(a.TagNumber) - Number(b.TagNumber);
          }
          if(numA) return -1;
          if(numB) return 1;
          // check for wordhood
          const wordA = /^[a-zA-Z]+$/.test(a.TagNumber);
          const wordB = /^[a-zA-Z]+$/.test(b.TagNumber);
          if(wordA && wordB){
           	return a.TagNumber.localeCompare(b.TagNumber);
          }
          if(wordA || wordB) return (wordA && -1) || 1;

          return 1; //or whatever logic to sort within non-alphanumeric values

        }
        response = response.sort(compare);

        for (var i = 0; i < response.length; i++) {
          let resData = {};
          resData.TagNumber = response[i].TagNumber;
          resData.Footnote = self.getFootNoteText(response[i].FootnoteId);

          if (response[i].Column != "" && response[i].Column != null) {
            if (response[i].Column.length) {
              var columnArray = [];
              if (response[i].Column.indexOf(",") < 0) {
                columnArray[0] = response[i].Column;
              } else {
                columnArray = response[i].Column.split(",");
              }

              columnArray.forEach(element => {
                let chkTitleSuperScript = gridConfigForColumnTitle.columns[
                  element.trim()
                ].title.indexOf("<sup>[" + response[i].TagNumber + "]</sup>");

                if (chkTitleSuperScript < 0) {
                  gridConfigForColumnTitle.columns[element.trim()].title =
                    gridConfigForColumnTitle.columns[element.trim()].title +
                    "<sup>[" +
                    response[i].TagNumber +
                    "]</sup>";
                }
                // ----------------------------------------------
                // Removed as it was breaking br in html template
                // ----------------------------------------------
                // Pdf header Superscript
                // if (self.displayEUM) {
                //   $("table.pdf-table thead tr.EUMReport th").each(function() {
                //     if ($(this).attr("attr") == element) {
                //       $(this).html(
                //         gridConfigForColumnTitle.columns[element.trim()].title
                //       );
                //     }
                //   });
                // } else if (self.displayEPP) {
                //   $("table.pdf-table thead tr.EPPReport th").each(function() {
                //     if ($(this).attr("attr") == element) {
                //       $(this).html(
                //         gridConfigForColumnTitle.columns[element.trim()].title
                //       );
                //     }
                //   });
                // }
              });
            }
          } else if (
            response[i].Investments != null &&
            response[i].Investments != ""
          ) {
            if (response[i].Investments.length) {
              var investmentArray = [];
              if (response[i].Investments.indexOf(",") < 0) {
                investmentArray[0] = response[i].Investments;
              } else {
                investmentArray = response[i].Investments.split(",");
              }

              investmentArray.forEach(element => {
                var filterObj = gridDataForInvestmentAndGroup.filter(obj => {
                  let suppElement = " (Supplemental Units)";
                  return (
                    // obj.Investment.indexOf(element) >= 0

                    //element === obj.Investment.toString().split("Supplemental Units") ||
                    element === ( obj.Investment.toString().split(suppElement)) || 
                    element === (obj.Investment.toString().split("<sup>"))[0] || 
                    obj.Investment.toUpperCase().trimEnd().toString() === element

                    // obj.Investment === element ||
                    // (obj.Investment.toString().substring(0, element.length) ===
                    //   element &&
                    //   obj.Investment.toString()
                    //     .substring(element.length + 1)
                    //     .indexOf("Supplemental Units") > 0) ||
                    // (obj.Investment.toString().substring(0, element.length) ===
                    //   element &&
                    //   obj.Investment.toString()
                    //     .substring(element.length - 1)
                    //     .indexOf("<sup>[") > 0)
                  );
                });
                //   h => h.Investment == element
                // );
                if (filterObj.length) {
                  filterObj.forEach(item => {
                    item.Investment +=
                      "<sup>[" + response[i].TagNumber + "]</sup>";
                  });
                  let strInvestment = {
                    investment: filterObj[0].Investment,
                    tagNumber: response[i].TagNumber
                  };

                  //self.investmentSuperScript.push(strInvestment);
                }
              });
            }
          } else if (
            response[i].InvestmentGroup != "" &&
            response[i].InvestmentGroup != null
          ) {
            if (response[i].InvestmentGroup.length) {
              var investmentGroupArray = [];
              if (response[i].InvestmentGroup.indexOf(",") < 0) {
                investmentGroupArray[0] = response[i].InvestmentGroup;
              } else {
                investmentGroupArray = response[i].InvestmentGroup.split(",");
              }

              investmentGroupArray.forEach(element => {
                var filterObj = gridDataForInvestmentAndGroup.filter(
                  h => h.InvestmentGroup == element
                );
                if (filterObj.length) {
                  // filterObj.forEach(item => {
                  //   item.InvestmentGroup +=
                  //     "<sup>[" + response[i].TagNumber + "]</sup>";
                  // });
                  let strInvestmentGroup = {
                    investmentGroup: filterObj[0].InvestmentGroup,
                    tagNumber: response[i].TagNumber
                  };

                  self.investmentGroupSuperScript.push(strInvestmentGroup);
                }
              });
            }
          }
          self.footnotes.push(resData);
        }
        /** sort by numbers,alphabets then special characters for footnotes  */
        if (self.footnotes.length > 0) {
          let exp = /[!@#$%^&*_+\=\[\]{};':"\\|<>\/?]+/;

          let footnotesspecialcharacterlist = [];
          footnotesspecialcharacterlist = self.footnotes.filter(x =>
            exp.test(x.TagNumber[0])
          );
          if (footnotesspecialcharacterlist.length > 0) {
            self.footnotes = self.footnotes.filter(
              x => !exp.test(x.TagNumber[0])
            );
          }

          let uniqNotesByTagNumber = {};

          function getKey(k) {
            return k.TagNumber; 
          };

          self.footnotes.forEach(item => {
            uniqNotesByTagNumber[getKey(item)] = item;
          })


          self.footnotes = Object.keys(uniqNotesByTagNumber).map(item => {
            return uniqNotesByTagNumber[item];
          })

          // No need to footnotes by tagNumber here, as it already done in response
          // self.footnotes = self.footnotes.sort((a, b) => {
          //   if (a.TagNumber == b.TagNumber) {
          //     return 0;
          //   }
          //   return a.TagNumber > b.TagNumber ? 1 : -1;
          // });
          if (footnotesspecialcharacterlist.length > 0) {
            self.footnotes = self.footnotes.concat(
              footnotesspecialcharacterlist
            );
          }
        }
      }
    },

    getSuperScript(e) {
      const self = this;
      $("#pdf-template tr").each(function() {
        let investRow = $(this)[0];
        if ($(this)[0].className == "investmentGrp-tr") {
          let invGrpSupCount = 0;
          if (self.investmentGroupSuperScript.length) {
            for (var i = 0; i < self.investmentGroupSuperScript.length; i++) {
              if (
                investRow.innerHTML.indexOf(
                  self.investmentGroupSuperScript[i].investmentGroup
                ) > 0
              ) {
                invGrpSupCount = invGrpSupCount + 1;
                if (
                  invGrpSupCount > 1 
                  &&
                  investRow.innerHTML.indexOf(
                    "<sup>[" +
                      self.investmentGroupSuperScript[i].tagNumber +
                      "]</sup>"
                  ) < 0
                ) {

                  investRow.innerHTML = _.replace(
                    investRow.innerHTML,
                      "</sup></td>",
                      "</sup><sup>[" +
                      self.investmentGroupSuperScript[i].tagNumber +
                      "]</sup></td>"
                      // "<sup>[" +
                      //   self.investmentGroupSuperScript[i].tagNumber +
                      //   "]</sup></p></td>"
                  );
                } 
                
                else {
                  if (investRow.innerHTML.indexOf("<sup>") < 0) {
                    investRow.innerHTML = _.replace(
                      investRow.innerHTML,
                      self.investmentGroupSuperScript[i].investmentGroup,
                      self.investmentGroupSuperScript[i].investmentGroup +
                        "<sup>[" +
                        self.investmentGroupSuperScript[i].tagNumber +
                        "]</sup>"
                    );
                  }
                }
              }
            }
          }
        } else if ($(this)[0].className == "investment-tr") {
          let invSupCount = 0;
          if (self.investmentSuperScript.length) {
            for (var i = 0; i < self.investmentSuperScript.length; i++) {
              let supplementalUnits = investRow.innerHTML.indexOf(
                "(Supplemental Units)"
              );
              let invTitle = investRow.innerHTML.indexOf(
                self.investmentSuperScript[i].investment
              );
              if (invTitle > 0) {
                invSupCount = invSupCount + 1;
                if (
                  invSupCount > 1 &&
                  investRow.innerHTML.indexOf(
                    "<sup>[" +
                      self.investmentSuperScript[i].tagNumber +
                      "]</sup>"
                  ) < 0
                ) {
                  investRow.innerHTML = _.replace(
                    investRow.innerHTML,
                    "</sup></td>",
                    "</sup><sup>[" +
                      self.investmentSuperScript[i].tagNumber +
                      "]</sup></td>"
                  );
                } else {
                  if (investRow.innerHTML.indexOf("<sup>") < 0) {
                    if (supplementalUnits > 0) {
                      investRow.innerHTML = _.replace(
                        investRow.innerHTML,
                        self.investmentSuperScript[i].investment +
                          " (Supplemental Units) ",
                        self.investmentSuperScript[i].investment +
                          " (Supplemental Units) <sup>[" +
                          self.investmentSuperScript[i].tagNumber +
                          "]</sup>"
                      );
                    } else {
                      investRow.innerHTML = _.replace(
                        investRow.innerHTML,
                        self.investmentSuperScript[i].investment,
                        self.investmentSuperScript[i].investment +
                          "<sup>[" +
                          self.investmentSuperScript[i].tagNumber +
                          "]</sup>"
                      );
                    }
                  }
                }
              }
            }
          }
        }
      });

      // var grid = $("#" + self.EUMGridConfig.grid.gridId).data("kendoGrid");
      var grid = e.sender;
      if (grid.tbody.find("tr").length) {
        grid.tbody.find("tr").each(function(index) {
          if ($(this)[0].className == "k-grouping-row") {
            let groupHeaderRow = $(this)[0];
            let grdInvGrpSupCount = 0;
            if (self.investmentGroupSuperScript.length) {
              for (var i = 0; i < self.investmentGroupSuperScript.length; i++) {
                let groupHeaderData = groupHeaderRow.innerHTML.indexOf(
                  self.investmentGroupSuperScript[i].investmentGroup
                );

                if (groupHeaderData > 0) {
                  //console.log("Data > 0", groupHeaderRow.innerHTML.indexOf("<sup>"));
                  grdInvGrpSupCount = grdInvGrpSupCount + 1;
                  if (
                    grdInvGrpSupCount > 1
                    &&
                    groupHeaderRow.innerHTML.indexOf(
                      "<sup>[" +
                        self.investmentGroupSuperScript[i].tagNumber +
                        "]</sup>"
                    ) < 0
                  ) {
                    
                    groupHeaderRow.innerHTML = 
                    // groupHeaderRow.innerHTML + "<sup>[" + self.investmentGroupSuperScript[i].tagNumber +"]</sup>";
                    
                    _.replace(
                      groupHeaderRow.innerHTML,
                      "</p></td>",
                      "<sup>[" +
                        self.investmentGroupSuperScript[i].tagNumber +
                        "]</sup></p></td>"
                    );

                    
                  } 
                  else {

                    if (groupHeaderRow.innerHTML.indexOf("<sup>") < 0) {
                      groupHeaderRow.innerHTML = _.replace(
                        groupHeaderRow.innerHTML,
                        self.investmentGroupSuperScript[i].investmentGroup,
                        self.investmentGroupSuperScript[i].investmentGroup +
                          "<sup>[" +
                          self.investmentGroupSuperScript[i].tagNumber +
                          "]</sup>"
                      );
                    }

                  }
                }
              }
            }
          } else {
            let gridRow = $(this)[0];
            let grdInvSupCount = 0;
            if (self.investmentSuperScript.length) {
              for (var i = 0; i < self.investmentSuperScript.length; i++) {
                let supplementalUnits = gridRow.innerHTML.indexOf(
                  "(Supplemental Units)"
                );
                let gridRowData = gridRow.innerHTML.indexOf(
                  self.investmentSuperScript[i].investment
                );

                if (gridRowData > 0) {
                  grdInvSupCount = grdInvSupCount + 1;
                  //console.log(">>>",gridRow.innerHTML)
                  if (
                    grdInvSupCount > 1 &&
                    gridRow.innerHTML.indexOf(
                      "<sup>[" +
                        self.investmentSuperScript[i].tagNumber +
                        "]</sup>"
                    ) < 0
                  ) {

                    
                    gridRow.innerHTML = _.replace(
                      gridRow.innerHTML,
                    "</sup></td>",
                    "</sup><sup>[" +
                        self.investmentSuperScript[i].tagNumber +
                        "]</sup></td>"
                    );

                  } else {
                    if (gridRow.innerHTML.indexOf("<sup>") < 0) {
                      if (supplementalUnits > 0) {
                        gridRow.innerHTML = _.replace(
                          gridRow.innerHTML,
                          self.investmentSuperScript[i].investment +
                            " (Supplemental Units) ",
                          self.investmentSuperScript[i].investment +
                            " (Supplemental Units) <sup>[" +
                            self.investmentSuperScript[i].tagNumber +
                            "]</sup>"
                        );
                      } else {
                        gridRow.innerHTML = _.replace(
                          gridRow.innerHTML,
                          self.investmentSuperScript[i].investment,
                          self.investmentSuperScript[i].investment +
                            "<sup>[" +
                            self.investmentSuperScript[i].tagNumber +
                            "]</sup>"
                        );
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
    }
  }
};
</script>

<style>
#btnExportPdf span {
  font-size: 25px;
}

.pdf-page1 {
  font-family: "DejaVu Sans", "Arial", sans-serif;
}

.pdf-table > tbody:nth-child(2n + 1) > tr,
.pdf-table > tbody:nth-child(2n + 1) > tr {
  background-color: #dee2e6;
}

.pdf-table td {
  font-size: 9px !important;
}

.pdf-table th {
  font-size: 9px !important;
}

th.th-head {
  border: 1px solid !important;
  border-bottom: 2px solid !important;
}

th.th-top-EPP {
  border-top: 1px solid !important;
  border-bottom: 1px solid !important;
}

th.th-top-EPP-EPP {
  border-top: 1px solid !important;
  /* border-bottom: 1px solid !important; */
}
.potential {
  text-align: center;
  margin-bottom: 20px;
  text-transform: uppercase;
  font-size: 12px;
}

.pdf-page1 {
  position: relative;
  margin: 30px;
  padding: 0.4in 0.3in;
  color: #333;
  background-color: #fff;
  /* box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3); */
  /* box-sizing: border-box; */
  margin-left: 15px !important;
  margin-right: 15px !important;
  margin-top: 30px;
  margin-bottom: 30px;
}

h6 {
  text-align: center !important;
}

.pdf-table {
  width: 110%;
  height: 100%;
}

td {
  height: 20px;
  padding-right: 5px !important;
}

.total-class td {
  border-bottom: 1px solid;
  padding-top: 2%;
}

@media print {
  .btn-primary {
    display: none !important;
  }
}

.FMVImgcentre {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.FMVbottomdoubleborder {
  border-bottom: 4px double #333;
}

.FMVParabold {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
  font-family: Arial, serif;
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: bold;
  text-align: center;
}

.FMVParatext {
  font-family: Arial, serif;
  font-size: 14px;
  color: rgb(0, 0, 0);
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
}

.FMVcolSpan {
  width: 100px;
  display: inline-block;
}

.k-header {
  text-align: center !important;
}
.border_right {
  border-right: 1px solid !important;
}
.text_center {
  text-align: center !important;
}
.text_left {
  text-align: left !important;
}
.fullborder {
  border-top: 1px solid !important;
  border-right: 1px solid !important;
  border-left: 1px solid !important;
  border-bottom:none !important;
  /* //border-bo: 1px solid !important; */
}

.pdf-footnote2 {
  font-size: 7px;
  white-space: pre-wrap;
}

.pdf-footnote {
  font-size: 10px;
  padding-left: 1.5em;
  text-indent: -2em;
}

table thead tr.EUMReport > th {
  text-align: center;
}
table thead tr.EPPReport > th {
  text-align: center;
}
table#pdf-template > thead tr:nth-child(1) > td {
  text-align: center;
}

table tbody tr > td {
  text-align: right;
}
</style>
